import { API_ROUTES } from '../constants/api'
import {
  UserRole,
  type AuthSession,
  type AuthUser,
} from '../constants/auth'
import { api, ApiError } from './api-client'
import { clearAuthSession, writeAuthSession } from './auth-storage'

type Raw = Record<string, unknown>

function str(value: unknown, fallback = ''): string {
  return value == null ? fallback : String(value)
}

function mapUser(raw: Raw): AuthUser {
  const role = str(raw.role)
  return {
    id: str(raw.id),
    role:
      role === UserRole.Admin ||
      role === UserRole.Customer ||
      role === UserRole.Vendor
        ? role
        : UserRole.Customer,
    vendorId: raw.vendorId ? str(raw.vendorId) : null,
    name: raw.name ? str(raw.name) : null,
    phone: raw.phone ? str(raw.phone) : null,
    email: raw.email ? str(raw.email) : null,
    phoneVerified: Boolean(raw.phoneVerified),
    emailVerified: Boolean(raw.emailVerified),
    isActive: raw.isActive !== false,
  }
}

function mapSession(raw: Raw): AuthSession {
  return {
    accessToken: str(raw.accessToken),
    refreshToken: str(raw.refreshToken),
    user: mapUser((raw.user as Raw) ?? {}),
  }
}

export async function loginWithPassword(
  email: string,
  password: string,
): Promise<AuthSession> {
  const session = mapSession(
    await api.postPublic<Raw>(API_ROUTES.authLogin, { email, password }),
  )
  writeAuthSession(session)
  return session
}

export async function fetchCurrentUser(): Promise<AuthUser> {
  return mapUser(await api.get<Raw>(API_ROUTES.authMe))
}

export async function logoutSession(refreshToken?: string | null): Promise<void> {
  try {
    await api.post(API_ROUTES.authLogout, {
      ...(refreshToken ? { refreshToken } : {}),
    })
  } catch (error) {
    if (!(error instanceof ApiError)) throw error
  } finally {
    clearAuthSession()
  }
}
